import React, { useState } from "react"
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { CardMedia, imageListItemBarClasses } from "@mui/material";


type ComponentProps = {
  imageSrc: string, 
  title: string,
  description: string,
}

const BigItem = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'left',
  color: theme.palette.text.secondary,
}));


const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  boxShadow: 'none',
  borderColor: 'blue',
  color: theme.palette.text.secondary,
  margin: theme.spacing(1),
}));


export default function ExpungeGrid(props: ComponentProps){
  const {imageSrc,title,description} = props
  return (
  <Grid container
  direction = "row"
  alignItems="center"
  sx = {{
        margin: 'auto',
        marginBottom: '20px',
        bgcolor: 'grey.200',
        boxShadow: 100,
        borderRadius: 8,
        p: 4,
        minWidth: 300,
        width: 900,
        height: 200
    
  }}
  >
    <Grid item xs={2}> 
        <Box
          component={"img"}
          src={imageSrc}
          sx={{
            alignItems: 'left',
            bgcolor: 'transparent',
            p: 2,
          }}
        />
    </Grid>
    <Grid item xs = {9} >
        <Grid container 
              spacing={0}
              direction = "column"
              alignItems="flex-start"
              justifyContent = "flex-start"
              sx = {{
              }}>
          <Grid item xs={9}>
            <Box 
            sx={{
              fontFamily: 'Roboto DM Sans Times New Roman Sans-serif',
              fontSize: 22, 
              fontWeight: 'bold',
              mb: 2,
              alignItems: 'left',
            }}>
              {title}
            </Box>
          </Grid>
          <Grid item xs={9}>
            <Box 
            sx={{ 
              fontFamily: 'serif',
              fontSize: 16, 
              textAlign: 'left',
            }}>
              {description}
            </Box>
          </Grid>
        </Grid>
    </Grid>
  </Grid>
  )
}